import type { Metric } from '../types/profile'

export const headlineMetrics: Metric[] = [
  {
    value: '20',
    label: 'Industrial sectors directed',
    detail:
      'Breadth of UK manufacturing strategy held under a single directorship.',
    emphasis: true,
  },
  {
    value: '1,000 → 30',
    label: 'Business support products rationalised',
    detail:
      'A thousand overlapping government offers reduced to thirty coherent ones.',
    emphasis: true,
  },
]

export const capitalMetrics: Metric[] = [
  {
    value: '3',
    label: 'National institutions co-established',
    detail: 'UK Green Investment Bank, ATI and the Advanced Propulsion Centre.',
  },
  {
    value: '4',
    label: 'Continents of manufacturing overseen',
    detail: 'UK, Europe, India and China aerospace operations.',
  },
  {
    value: '2',
    label: 'CEO successions governed',
    detail: 'Appointment, reward alignment and onboarding through transition.',
  },
  {
    value: '5',
    label: 'Board committees chaired',
    detail: 'Audit & Risk, Remuneration, Employee Benefit Trust and boards.',
  },
  {
    value: '30+',
    label: 'Years at executive and board level',
    detail: 'Continuous senior responsibility in industry and government.',
  },
  {
    value: '1',
    label: 'Sovereign defence acquisition',
    detail:
      'Ministry of Defence purchase of Sheffield Forgemasters, governed to completion.',
  },
]
